var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
    stroke: "#16191E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43431 12.2225C8.63232 12.0245 8.73133 11.9255 8.84549 11.8884C8.94591 11.8558 9.05409 11.8558 9.15451 11.8884C9.26867 11.9255 9.36768 12.0245 9.56569 12.2225L11.6059 14.2627C11.8039 14.4608 11.9029 14.5598 11.94 14.6739C11.9726 14.7743 11.9726 14.8825 11.94 14.9829C11.9029 15.0971 11.8039 15.1961 11.6059 15.3941L9.56569 17.4343C9.36768 17.6323 9.26867 17.7313 9.15451 17.7684C9.05409 17.8011 8.94591 17.8011 8.84549 17.7684C8.73133 17.7313 8.63232 17.6323 8.43431 17.4343L6.39411 15.3941C6.1961 15.1961 6.0971 15.0971 6.06001 14.9829C6.02738 14.8825 6.02738 14.7743 6.06001 14.6739C6.0971 14.5598 6.1961 14.4608 6.39411 14.2627L8.43431 12.2225Z",
    fill: "#16191E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrading);
export default __webpack_public_path__ + "static/media/trading.c6358c5848c31913c308a1044363a5c5.svg";
export { ForwardRef as ReactComponent };